import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  tab: {
    fontFamily: theme.typography.h1.fontFamily,
    fontWeight: theme.typography.h1.fontWeight,
    color: theme.palette.primary.main,
  },
}));
